/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const SearchSm = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M24.6 22.58l-4.89-4.89a11 11 0 1 0-1.9 1.93l4.87 4.88a1.39 1.39 0 0 0 1 .4 1.39 1.39 0 0 0 1-.4 1.36 1.36 0 0 0-.08-1.92zM2 11a9 9 0 1 1 9 9 9 9 0 0 1-9-9z" /><path d="M4.33 6.6h6.37L12 8.2H3.52a7.25 7.25 0 0 0-.42 1.6h10.15v.8h-.85a.8.8 0 1 0 0 1.6h.88v1.6H3.52a8.34 8.34 0 0 0 .77 1.52h8.11v.86a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 .8-.8V9.34h.27a.8.8 0 0 0 0-1.6h-1.42l-1.72-2.17A1.61 1.61 0 0 0 10.7 5h-5a7.89 7.89 0 0 0-1.37 1.6z" /><path d="M10 12.2a.8.8 0 0 0-.8-.8H3a8.46 8.46 0 0 0 .26 1.6H9.2a.8.8 0 0 0 .8-.8z" />
      </g>
    </svg>
  </span>
);

SearchSm.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

SearchSm.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default SearchSm;
